'use client';

import { useRedirectTry } from '@/app/[locale]/_components/use-redirect-try';
import { Button } from '@/app/components/ui/button';
import { reportEvent } from '@/app/utils';

interface BlogCtaProps {
  buttonLabel: string;
  buttonHref: string;
}

export function BlogCta({ buttonLabel, buttonHref }: BlogCtaProps) {
  const handleRedirect = useRedirectTry();
  const isExternal = /^https?:\/\//.test(buttonHref);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    reportEvent('blog_cta_click', {
      element_name: 'blog - cta',
      cta_href: buttonHref,
    });
    if (!isExternal) {
      event.preventDefault();
      handleRedirect(buttonHref, 'blog - cta');
    }
  };

  return (
    <div className="my-[40px] flex w-full justify-center sm:my-[28px]">
      <a
        href={buttonHref}
        target={isExternal ? '_blank' : undefined}
        rel={isExternal ? 'noopener noreferrer' : undefined}
        onClick={handleClick}
        data-google-interstitial="false"
      >
        <Button variant="primary" size="lg">
          {buttonLabel}
        </Button>
      </a>
    </div>
  );
}
